export default __webpack_public_path__ + "static/media/5.ceac9dde.jpg";